import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Visit from "@/components/Visit";
import BookingSection from "@/components/BookingSection";
import TableBooking from "@/components/TableBooking";
import BarMenu from "@/components/BarMenu";
import WineClub from "@/components/WineClub";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <div className="bg-[#FDFBF7]" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Visit />
      <BookingSection />
      <BarMenu />
      <TableBooking />
      <WineClub />
      <Footer />
    </div>
  );
}
